import { connect } from 'react-redux'
import Generator from './Generator'

export default connect(store => ({ isHorizontal: store.icoSettings.isHorizontal }))(Generator)
